export default __webpack_public_path__ + "static/media/front_page_3.dfb688b9.jpg";